<template>
  <div class="pc-nav-bg" :class="announcement.show? 'show-announcement':''" v-show="!props.isMobile"> 
    <nav class=" pc-navbar">
    <Announcement v-if="announcement.show" :announcement="announcement" @closeAnnouncement="closeAnnouncement"></Announcement>
    <div class="navbar">
      <div class="nav-container">
        <div class="navbar-content">
          <a class="navbar-brand " href="/"> 
            <div class="logo-img has-system-logo" v-if='systemInfo.system_logo'>
              <img v-if="systemInfo.system_logo" :src="BASE_URL + systemInfo.system_logo" alt="logo" class="logo-img-img">
            </div>
            <span class="logo-text">{{systemInfo.system_name}}</span>
          </a>
          <!-- <a class="navbar-brand" href="/" v-else> 
            <div class="logo-img">             
              <i class="iconfont icon-envelope text-gray-700" style="font-size: 20px;"></i>
            </div>
            <span class="logo-text">{{systemInfo.system_name?systemInfo.system_name:'星海'}}</span>
          </a> -->

          <div class="nav-links">
            <router-link
              to="/mall"
              class="px-3 py-2 text-sm font-medium rounded-md text-gray-300"
              >商品商城</router-link
            >
            <router-link
              to="/orders"
              class="px-3 py-2 text-sm font-medium rounded-md text-gray-300"
              >订单查询</router-link
            >
            <router-link
              to="/utilities"
              class="px-3 py-2 text-sm font-medium rounded-md text-gray-300"
              >实用工具</router-link
            >
            <router-link
              to="/help"
              class="px-3 py-2 text-sm font-medium rounded-md text-gray-300"
              >帮助中心</router-link
            >
            <router-link
              to="/about"
              class="px-3 py-2 text-sm font-medium rounded-md text-gray-300"
              >关于我们</router-link
            >
          </div>
          <div class="auth-buttons" v-if="!isLoggedIn">            
            <router-link
              to="/login"
              class="px-3 py-2 text-sm font-medium rounded-md text-gray-300"
              >登录</router-link
            >
            <router-link
              to="/register"
              class="px-3 py-2 text-sm font-medium rounded-md text-gray-300"
              >注册</router-link
            >
          </div>
          <div class="auth-buttons auth-dropdown" v-else>
            <div class="flex items-center justify-between">

            <div class="recharge-btn cursor-pointer flex items-center justify-center px-3 py-1.5 text-sm font-medium text-white bg-gray-700 rounded" @click="goToPage('recharge')"> 
              <i class="mr-2 iconfont icon-wallet" font-size="14px"></i><span>充值</span>
            </div>
            <el-dropdown trigger="click" popper-class="auth-dropdown-menu" >
              <div class="flex items-center justify-between">
               
                <span class="auth-title text-gray-300 cursor-pointer ml-20">
                  <!-- {{ userEmail.substring(0,userEmail.indexOf('@')) }} -->
                  {{allUserInfo.nickname}}
                  <span class="ml-2 mr-2"><span class="px-2 py-0.5 bg-yellow-400 text-yellow-900 rounded text-sm font-medium" v-if="allUserInfo.member_level && allUserInfo.member_level.id >1">{{allUserInfo.member_level? allUserInfo.member_level.name:''}}</span></span>
                  <i class="iconfont icon-caret-down text-gray-300" style="font-size: 14px;"></i>
                </span>
              </div>
              
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <div>
                      <div class="flex items-center">
                        <!-- {{ userEmail.substring(0,userEmail.indexOf('@')) }} -->
                        <div class="user-email text-gray-900 font-medium text-md">{{allUserInfo.nickname}}</div>  
                        <div class="ml-2 px-2 py-0.5 bg-yellow-400 text-yellow-900 rounded text-sm font-medium" v-if="allUserInfo.member_level && allUserInfo.member_level.id >1">{{allUserInfo.member_level? allUserInfo.member_level.name:''}}</div>
                      </div>
                      <div class="primary-color text-sm font-medium mt-1">
                        余额：¥{{allUserInfo.balance || '0.00'}}
                      </div>
                    </div>                    
                  </el-dropdown-item> 
                  <el-dropdown-item @click="goToAccount">
                    <i class="iconfont icon-user mr-2" style="font-size: 14px;"></i> 我的账户
                  </el-dropdown-item>     
                  <el-dropdown-item @click="goToOrder">
                    <i class="iconfont icon-shopping-bag mr-2" style="font-size: 14px;"></i>订单记录
                  </el-dropdown-item>     
                  <el-dropdown-item @click="goToRechargeOrder">
                    <i class="iconfont icon-wallet mr-2" style="font-size: 14px;"></i>充值记录
                  </el-dropdown-item> 
                   
                  <el-dropdown-item @click="goToBillOrder">
                    <i class="iconfont icon-history mr-2" style="font-size: 14px;"></i>账单记录
                  </el-dropdown-item>        
                  
                  <el-dropdown-item @click="goTorebateCenter" v-if="systemInfo.distribution_enabled == 1">
                    <i class="iconfont icon-money-bill-wave mr-2" style="font-size: 14px;"></i>返利中心
                  </el-dropdown-item>                          
                  <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            
          </div>
          </div>
        </div>
      </div>
    </div>
      
    </nav>
  </div>
</template>
<script setup>
import { defineProps,defineEmits, ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import {UserFilled } from "@element-plus/icons-vue";
import emitter from '@/utils/eventBus';
import { userApi } from '@/api';
import {BASE_URL} from '@/utils/request'

import Announcement from "@/components/announcement.vue";
// import ReactIcon from "./reactIcon.vue";

const props = defineProps({
  isMobile: {
    type: Boolean,
    default: false,
  },
  systemInfo: {
    type: Object,
    default: () => ({}),
  },
  announcement:{
    type: Object,
    default: () => ({})
  }
});
const emit = defineEmits(['closeAnnouncement'])
const router = useRouter();
const isLoggedIn = ref(false);
const userEmail = ref('');
const allUserInfo = ref({})
//关闭公告
const closeAnnouncement = ()=>{ 
  emit('closeAnnouncement')
}
// 检查登录状态
const checkLoginStatus = () => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('userInfo');
  const info = localStorage.getItem('allUserInfo')
  const email = user ? JSON.parse(user).email : '';
  isLoggedIn.value = !!token;
  userEmail.value = email || '';

  allUserInfo.value = info ? JSON.parse(info) : {}
};

// 监听 localStorage 变化
const handleStorageChange = (e) => {
  if (e.key === 'token' || e.key === 'email' || e.key === 'allUserInfo') {
    checkLoginStatus();
  }
};

// 跳转到账户页面
const goToAccount = () => {
  router.push('/personal/info');
};

// 跳转到订单记录页面
const goToOrder = () => {
  router.push('/personal/order');
};
const goToRechargeOrder = ()=>{
  router.push('/personal/rechargeOrder')
}
const goToBillOrder = ()=>{
  router.push('/personal/billRecords')
}

const goTorebateCenter = ()=>{
  router.push('/personal/rebateCenter')
}
// 处理退出登录
const handleLogout = () => {
  userApi.logout().then(res=>{
    console.log(res);
    ElMessage.success('退出成功');
  })
  setTimeout(()=>{
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('allUserInfo')
    isLoggedIn.value = false;
    userEmail.value = '';
    router.push('/login');
  },200)
};
//去充值页面
const goToPage = (page)=>{
  router.push(`/${page}`);
}
// 监听登录状态变化事件
const handleLoginStatusChange = () => {
  checkLoginStatus();
};

onMounted(() => {
  checkLoginStatus();
  window.addEventListener('storage', handleStorageChange);
  emitter.on('loginStatusChange', handleLoginStatusChange);
});

onUnmounted(() => {
  window.removeEventListener('storage', handleStorageChange);
  emitter.off('loginStatusChange', handleLoginStatusChange);
});
</script>
<style lang="scss">

.auth-dropdown-menu{
  display: none;
  width:12rem;
  .el-dropdown-menu__item{
    padding: 0.5rem 1rem !important;
    font-size: 0.875rem !important;
    &:not(.is-disabled):focus, .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: #f3f4f6;
        color: #374151;

    }
  }
  
}
@media (min-width: 768px) {
  .auth-dropdown-menu{
    display: block;
  }
}
</style>
<style scoped lang="scss">
.pc-nav-bg {
  height: 56px;
  &.show-announcement{
    height: calc(56px + 3rem)
  }
  .pc-navbar {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 1000;
    .navbar{      
      background-color: #1f2937;
    }
    .nav-container {
      width: 100%;
    }
    .logo-img {      
      max-width: 50px;
      margin-right: 10px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      &.has-system-logo{     
        max-width: 40px;
        width: 40px;
        height: 40px;
        overflow: hidden;
        .logo-img-img{
          width: 40px;
          height: 40px;
          object-fit: cover;
        }
    }
    }
    
    .logo-text {
      color: #fff;
      font-size: 1.125rem;
      font-weight: 600;
    }
    .auth-dropdown{
      .auth-title{
        // color: #fff;
        font-size: 1rem;
      }
      .recharge-btn{
        &:hover{
          background-color: #4B5562;
        }
      }
    }
  }
} 
</style>
